import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[axOverlayContent]',
  standalone: true,
})
export class OverlayContentDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
